import { useField } from "formik";
import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";
import styles from "../TextInput/TextInputWithFormik.module.scss";
import Dropdown from "./Dropdown";

/**
 * Integration with formik of dropdown component
 */
const DropdownWithFormik = ({
  label,
  required = false,
  containerClass = "",
  ...props
}) => {
  const [, meta, helpers] = useField(props);
  const { t } = useTranslation();

  const { value } = meta;

  const { setValue, setTouched } = helpers;

  const error = meta.touched && !!required && !meta.value;

  return (
    <Form.Group className={!!containerClass ? containerClass : "mb-3"}>
      <Form.Label>
        {label}{" "}
        {!required && (
          <span className={styles.optional}>({t("general.optional")})</span>
        )}
      </Form.Label>
      <Dropdown
        instanceId={props.name}
        id={`qa-select-${props.name}`}
        value={value}
        onChange={(option) => {
          setValue(option);
          setTouched(true, true);
        }}
        onMenuClose={() => setTouched(true, true)}
        isValid={meta.touched && meta.value}
        isInvalid={error}
        required={required}
        {...props}
      />
      {error && (
        <Form.Control.Feedback type="invalid">
          {meta.error}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

DropdownWithFormik.propTypes = {
  /** Dropdown's title */
  label: PropTypes.string.isRequired,
  /** This props display an error message if the input it's empty
   * and has been touched however this it's just UI behaviour
   */
  required: PropTypes.bool,
  /** Replaces input's default container class completly */
  containerClass: PropTypes.string,
};

export default DropdownWithFormik;
